import { ChangeDetectionStrategy, Component, computed, effect, inject } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { SeSecurityStore } from "./se.security.store";
import { S25ObjectFilestorePoolComponent } from "../../standalone/s25.object.filestore.pool.component";
import { FILESTORE_POOL_MAX_FILES_PER_OBJECT } from "../../util/filestore.util";
import { FILE_KEY_CONNECT25_HOME_SLIDESHOW_POOL } from "./se.connect25.constants";

@TypeManagerDecorator("s25-ng-se-connect25-hero-admin")
@Component({
    selector: "s25-ng-se-connect25-hero-admin",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25ObjectFilestorePoolComponent],
    template: `
        <h2>Connect25 home slideshow images</h2>
        <p class="ngFinePrint c-margin-bottom--single">
            Upload images for the Connect25 home page slideshow. When more than one image is present, they rotate
            automatically. Maximum {{ maxFiles }} images.
        </p>
        @if (canManagePool()) {
            <s25-ng-object-filestore-pool
                [objectTypeId]="-1"
                [objectId]="-1"
                [fileKey]="fileKey"
                [canView]="true"
                [canManage]="true"
                [introText]="''"
                [filesGroupLabel]="'Connect25 home slideshow'"
            />
        } @else {
            <p class="ngFinePrint">You need full Connect25 access to manage these files.</p>
        }
    `,
})
export class SeConnect25HeroAdminComponent {
    private readonly securityStore = inject(SeSecurityStore);

    readonly fileKey = FILE_KEY_CONNECT25_HOME_SLIDESHOW_POOL;
    readonly maxFiles = FILESTORE_POOL_MAX_FILES_PER_OBJECT;

    readonly canManagePool = computed(() => this.securityStore.hasFLSOverride());

    constructor() {
        effect(() => {
            void this.securityStore.ensureInitialized();
        });
    }
}
